export const FETCH_LOGS = {
    REQUEST: 'COMMON.LOG.FETCH_LOGS.REQUEST',
    SUCCESS: 'COMMON.LOG.FETCH_LOGS.SUCCESS',
    FAILED: 'COMMON.LOG.FETCH_LOGS.FAILED',
};

export const CLEAR_STATE = 'COMMON.LOG.CLEAR_STATE';
